import { jwtDecode } from 'jwt-decode';
import type { ZodType } from 'zod';

/**
 * This function is safe as in "exception safe"; it does not imply verification of the JWT.
 */
export const safeJwtDecode = <T>(
  token: string | null | undefined,
  schema: ZodType<T> | undefined = undefined,
): { success: true; value: T } | { success: false } => {
  if (token) {
    try {
      const decoded = jwtDecode<T>(token);
      const result = schema?.safeParse(decoded);
      if (result?.success) {
        return {
          success: true,
          value: result.data,
        };
      }
      return {
        success: false,
      };
    } catch {}
  }

  return { success: false };
};
